<template>
    <div class="container">
        <el-row :gutter="20" class="row">
            <el-col :span="24">
                <h2 class="title">浩范sass订单支付查询</h2>
            </el-col>
        </el-row>
        <!-- 新增的退款功能 -->
        <el-row :gutter="20" class="row">
            <el-col :span="24">
                <el-card class="refund-card">
                    <div slot="header" class="clearfix">
                        <span>浩范sass订单支付查询</span>
                    </div>
                    <el-form :inline="true" :model="queryOrderForm" class="refund-form">
                        <el-form-item label="订单号">
                            <el-input
                                v-model="queryOrderForm.OutTradeNo"
                                placeholder="请输入订单号"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="handleOrderQuery"
                                :loading="refundLoading"
                            >
                                查询
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <!-- 订单查询结果展示 -->
        <el-row :gutter="20" class="row" v-if="orderQueryResult && Object.keys(orderQueryResult).length > 0">
            <el-col :span="24">
                <el-card class="result-card">
                    <div slot="header" class="clearfix">
                        <span>查询结果</span>
                    </div>
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="电商唯一订单号">{{ orderQueryResult.outTradeNo }}</el-descriptions-item>
                        <el-descriptions-item label="皓范交易号">{{ orderQueryResult.tradeNo }}</el-descriptions-item>
                        <el-descriptions-item label="支付优惠金额">
                            <span v-if="orderQueryResult.discountAmount !== undefined">
                                ¥{{ (orderQueryResult.discountAmount / 100).toFixed(2) }}
                            </span>
                        </el-descriptions-item>
                        <el-descriptions-item label="实际支付金额">
                            <span v-if="orderQueryResult.cashAmount !== undefined">
                                ¥{{ (orderQueryResult.cashAmount / 100).toFixed(2) }}
                            </span>
                        </el-descriptions-item>
                        <el-descriptions-item label="交易状态">
                            <el-tag :type="getTradeStatusType(orderQueryResult.tradeStatus)">
                                {{ getTradeStatusText(orderQueryResult.tradeStatus) }}
                            </el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="错误码">{{ orderQueryResult.errcode }}</el-descriptions-item>
                        <el-descriptions-item label="错误信息">{{ orderQueryResult.errmsg }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>
            </el-col>
        </el-row>
        <!----------------------------------------------        -->


        <el-row :gutter="20" class="row">
            <el-col :span="24">
                <h2 class="title">浩范sass退款</h2>
            </el-col>
        </el-row>
        <!-- 新增的退款功能 -->
        <el-row :gutter="20" class="row">
            <el-col :span="24">
                <el-card class="refund-card">
                    <div slot="header" class="clearfix">
                        <span>浩范sass退款</span>
                    </div>
                    <el-form :inline="true" :model="refundForm" class="refund-form">
                        <el-form-item label="退款类型" in>
                            <el-select v-model="refundForm.orderType" placeholder="请选择">
                                <el-option
                                    v-for="item in orderTypeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="订单号">
                            <el-input
                                v-model="refundForm.outRefundNo"
                                placeholder="请输入订单号"
                                clearable
                            ></el-input>
                        </el-form-item>
<!--                        <el-form-item label="退款金额(元)">
                            <el-input
                                v-model="refundForm.refundAmount"
                                placeholder="请输入退款金额"
                                clearable
                            >
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>-->
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="handleRefund"
                                :loading="refundLoading"
                            >
                                退款
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>


<!----------------------------------------------        -->

        <el-row :gutter="20" class="row">
            <el-col :span="24">
                <h2 class="title">浩范sass退款查询</h2>
            </el-col>
        </el-row>

        <!-- 查询表单 -->
        <el-row :gutter="20" class="row">

            <el-col :span="24">
                <el-card class="refund-card">
                    <div slot="header" class="clearfix">
                        <span>浩范sass退款查询</span>
                    </div>
                    <el-form :inline="true" :model="queryForm" class="query-form">
                        <el-form-item label="退款类型" in>
                            <el-select v-model="queryForm.orderType" placeholder="请选择">
                                <el-option
                                    v-for="item in orderTypeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="退款单号">
                            <el-input
                                v-model="queryForm.outRefundNo"
                                placeholder="请输入退款单号"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="handleQuery"
                                :loading="loading"
                            >
                                查询
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <!-- 查询结果展示 -->
        <el-row :gutter="20" class="row" v-if="queryResult.list && queryResult.list.length > 0">
            <el-col :span="24">
                <el-table :data="queryResult.list" border style="width: 100%">
                    <el-table-column prop="outRefundSn" label="外部退款单号" width="180"></el-table-column>
                    <el-table-column prop="result.refundNo" label="退款单号" width="250"></el-table-column>
                    <el-table-column prop="result.refundAmount" label="退款金额" width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.result.errcode === 200">
                                ¥{{ scope.row.result.refundAmount / 100 }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="result.refundTotalAmount" label="总退款金额" width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.result.errcode === 200">
                                ¥{{ scope.row.result.refundTotalAmount / 100 }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="退款状态" width="120">
                        <template slot-scope="scope">
                            <el-tag
                                v-if="scope.row.result.errcode === 200"
                                :type="getRefundStatusType(scope.row.result.refundStatus)"
                            >
                                {{ getRefundStatusText(scope.row.result.refundStatus) }}
                            </el-tag>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="result.refundTime" label="退款时间" width="180">
                        <template slot-scope="scope">
                            <span v-if="scope.row.result.errcode === 200 && scope.row.result.refundTime">
                                {{ deal.timestamp(scope.row.result.refundTime) }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="result.errcode" label="错误码" width="100"></el-table-column>
                    <el-table-column prop="result.errmsg" label="错误信息">
                        <template slot-scope="scope">
                            <span v-if="scope.row.result.errcode !== 0" class="error-msg">
                                {{ scope.row.result.errmsg }}
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>



<!--//皓范：S2025111313062999949  手动退款  341.91
        皓范：S2025111222555022981  手动退款 61.8-->









    </div>
</template>

<script>
import { request } from '@/common/request';
import bus from '@/common/bus';
import { deal } from '@/common/main';

export default {
    name: 'RefundDetail',
    computed: {
        deal() {
            return deal;
        }
    },
    data() {
        return {
            id: 0,
            status: 'wait',
            context: '',
            active: 0,
            loading: false,
            refundLoading: false,
            queryOrderForm: {
                OutTradeNo: '',
            },
            queryForm: {
                outRefundNo: '',
                orderType:"order"
            },
            refundForm: {
                outRefundNo: '',
                orderType: 'order',
                refundAmount: '' // 添加退款金额字段
            },
            queryResult: {
                list: []
            },
            orderQueryResult: {

            },
            pageInfo: {
                items: {},
                order: {},
                goods: {},
                addr: {}
            },
            tableData: [],
            confirmVisible: false,
            confirmContent: '提示',
            refunt_state: 2,
            logs: [],
            orderTypeOptions:[
                {value: 'order', label: '普通订单', tips: "单号如：S2025100112000232255****"},
                {
                    value: 'order_spell',
                    label: '拼团订单',
                    tips: "单号如：P2025100112000232255****"
                },
                {value: 'order_right', label: '售后订单', tips: "单号如：W2025100112000232255****"}
            ]
        };
    },
    mounted() {},
    watch: {
        $route: {
            handler(to, from) {
                if (to.query.id && to.query.id != this.id && to.path == '/order-RefundDetail') {
                    this.id = to.query.id;
                    this.loadData();
                }
                //深度监听，同时也可监听到param参数变化
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleOrderQuery(){
            let url = '/payment/hotfanNew/orderTradeQuery'

            request.get(url, {
                OutTradeNo: this.queryOrderForm.OutTradeNo
            }).then((ret) => {
                if (ret.code === 1) {
                    this.orderQueryResult = ret.data.result;
                    if (!this.orderQueryResult || this.orderQueryResult.result === null) {
                        this.$message.error('订单不存在')
                        return
                    }
                    console.log('this.orderQueryResult', this.orderQueryResult)

                    //          cashAmount:51100
                    //          discountAmount:3000
                    //          errcode:200
                    //          errmsg:"success"
                    //          outTradeNo:"S2025111313062999949"
                    //          result:"eyJjYXNoQW1vdW50Ijo1MTEwMCwiZGlzY291bnRBbW91bnQiOjMwMDAsIm91dFRyYWRlTm8iOiJTMjAyNTExMTMxMzA2Mjk5OTk0OSIsInRyYWRlTm8iOiIzNDkxZmYyZjZiMTA0NGE3YjY4ZWQ1Zjc2MTY5ODI3ZCIsInRyYWRlU3RhdHVzIjoyfQ=="
                    //          tradeNo:"3491ff2f6b1044a7b68ed5f76169827d"
                    //          tradeStatus:2
                    this.$message.success('查询成功');
                } else {
                    this.$message.error(ret.msg);
                }
            }).finally(() => {
                this.refundLoading = false;
            });
        },
        handleQuery() {
            if (!this.queryForm.outRefundNo) {
                this.$message.warning('请输入退款单号');
                return;
            }

            this.haofanNewOrderRefundQuery();
        },

        haofanNewOrderRefundQuery() {
            this.loading = true;
            this.queryResult.list = []; // 清空之前的结果
            const _this = this;
            request.get('/payment/hotfanNew/orderRefundQuery',  this.queryForm).then((ret) => {
                if (ret.code === 1) {
                    // 处理查询成功逻辑
                    this.queryResult = ret.data;
                } else {
                    this.$message.error(ret.msg);
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        // 新增的退款功能方法
        handleRefund() {
            if (!this.refundForm.outRefundNo) {
                this.$message.warning('请输入订单号');
                return;
            }
            
            // 验证退款金额格式（如果填写了金额）
            if (this.refundForm.refundAmount && !/^\d+(\.\d{1,2})?$/.test(this.refundForm.refundAmount)) {
                this.$message.warning('退款金额格式不正确，请输入有效的数字');
                return;
            }
            
            let url='';
            let params = {
                outRefundNo: this.refundForm.outRefundNo
            };
            
            // 如果填写了退款金额，则添加到参数中（转换为分）
            if (this.refundForm.refundAmount) {
                params.refundAmount = Math.round(parseFloat(this.refundForm.refundAmount) * 100);
            }
            
            if (this.refundForm.orderType === 'order') {
                url = '/payment/hotfanNew/orderRefund'
            } else if (this.refundForm.orderType === 'order_spell') {
                url = '/payment/hotfanNew/spellSon/orderRefund'
            }else if (this.refundForm.orderType === 'order_right') {
                url = '/payment/hotfanNew/orderRightRefund'
            }
            
            this.refundLoading = true;
            request.get(url, params).then((ret) => {
                if (ret.code === 1) {
                    this.$message.success('退款申请已提交');
                } else {
                    this.$message.error(ret.msg);
                }
            }).finally(() => {
                this.refundLoading = false;
            });
        },



        // 获取退款状态文本
        getRefundStatusText(status) {
            const statusMap = {
                0: '退款中',
                1: '退款成功',
                2: '退款失败'
            };
            return statusMap[status] || '未知状态';
        },

        // 获取退款状态标签类型
        getRefundStatusType(status) {
            const typeMap = {
                0: 'warning',   // 退款中 - 警告色(橙色)
                1: 'success',   // 退款成功 - 成功色(绿色)
                2: 'danger'     // 退款失败 - 危险色(红色)
            };
            return typeMap[status] || 'info';
        },

        // 获取交易状态文本
        getTradeStatusText(status) {
            const statusMap = {
                1: '支付中',
                2: '支付成功',
                3: '支付失败'
            };
            return statusMap[status] || '未知状态';
        },

        // 获取交易状态标签类型
        getTradeStatusType(status) {
            const typeMap = {
                1: 'warning',   // 支付中 - 警告色(橙色)
                2: 'success',   // 支付成功 - 成功色(绿色)
                3: 'danger'     // 支付失败 - 危险色(红色)
            };
            return typeMap[status] || 'info';
        }
    }
};
</script>

<style lang="scss" scoped>
.row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin: 20px 0;
}

.query-form {
    background: #f5f7fa;
    padding: 20px;
    border-radius: 4px;

    :deep(.el-form-item) {
        margin-bottom: 0;
    }
}

.refund-card {
    margin-top: 20px;
}

.result-card {
    margin-top: 20px;
}

.refund-form {
    :deep(.el-form-item) {
        margin-bottom: 0;
    }
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
    background: #f0f2f5;
    border: 1px solid #dcdfe6;
}

.error-msg {
    color: #f56c6c;
    font-weight: bold;
}
</style>